import React from 'react'

const Social = () => {
  return (
    <div className="home_social">
        <a href="https://wa.me/5591981102017" className="home_social-icon" target='_blank'>
            <i className='uil uil-whatsapp'></i>
        </a>

        <a href="https://github.com/MateusBeltrao" className="home_social-icon" target='_blank'>
            <i className='uil uil-linkedin'></i>
        </a>

        <a href="" className="home_social-icon" target='_blank'>
            <i className='uil uil-github-alt'></i>
        </a>
    </div>
  )
}

export default Social